import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The blocker and the spotlight of a floating/sheet step.
 *
 * The BLOCKER is a transparent full-viewport layer: clicks do nothing (the
 * spotlit target is shown, not operated — "do, don't show" steps are a
 * non-goal) and a mousedown cannot pull focus out of the panel. The wheel is
 * not intercepted, so the document still scrolls and the spotlight follows.
 *
 * The SPOTLIGHT is one box around the target whose enormous spread shadow is
 * the scrim, so the hole is exactly the target plus padding with no masking or
 * SVG. Without a target it becomes a plain full-viewport scrim.
 */
export function Spotlight({ rect, padding, }) {
    const block = (event) => {
        event.preventDefault();
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "bk-coachmark__blocker", "aria-hidden": "true", onMouseDown: block, onClick: block }), rect ? (_jsx("div", { className: "bk-coachmark__spotlight", "aria-hidden": "true", style: {
                    transform: `translate(${Math.round(rect.left - padding)}px, ${Math.round(rect.top - padding)}px)`,
                    width: Math.round(rect.width + padding * 2),
                    height: Math.round(rect.height + padding * 2),
                } })) : (_jsx("div", { className: "bk-coachmark__spotlight bk-coachmark__spotlight--full", "aria-hidden": "true" }))] }));
}
//# sourceMappingURL=spotlight.js.map